(function () {
  var productCache = {};
  var processed = new WeakSet();

  function parseSalePercent(tags) {
    if (!Array.isArray(tags)) {
      if (typeof tags === 'string') {
        tags = tags.split(',');
      } else {
        tags = [];
      }
    }

    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i] || '').trim();
      var match = tag.match(/^sale-badge:\s*(?:最大)?\s*(\d+)/i);
      if (match) return parseInt(match[1], 10) || 0;
    }

    return 0;
  }

  function isSaleExcluded(product) {
    var tags = Array.isArray(product && product.tags) ? product.tags : [];

    return Boolean(product && product.gift_card) || tags.some(function (tag) {
      tag = String(tag || '').trim();
      return tag === 'sale-exclude' || tag === 'SALE対象外' || tag === 'セール対象外' || tag === '対象外';
    });
  }

  function formatMoney(cents) {
    var format = (window.__pagefly_setting__ && window.__pagefly_setting__.moneyFormat) || '¥{{amount_no_decimals}}';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var token = match ? match[1] : 'amount_no_decimals';
    var precision = token.indexOf('no_decimals') !== -1 ? 0 : 2;
    var thousands = token.indexOf('space_separator') !== -1 ? ' ' : ',';
    var decimal = token.indexOf('comma_separator') !== -1 ? ',' : '.';
    if (token.indexOf('comma_separator') !== -1) thousands = '.';

    var value = (Number(cents || 0) / 100).toFixed(precision);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    value = parts[0] + (parts[1] ? decimal + parts[1] : '');

    return format.replace(placeholderRegex, value);
  }

  function getHandleFromUrl(href) {
    if (!href) return null;

    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        cache: 'force-cache'
      })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .catch(function () {
          return null;
        });
    }

    return productCache[handle];
  }

  function findProductData(priceWrap) {
    var productId = priceWrap.getAttribute('data-product-id');
    var productNode = priceWrap.querySelector('[data-product-id]') || priceWrap.closest('[data-product-id]');

    if (!productId && productNode) {
      productId = productNode.getAttribute('data-product-id');
    }

    if (!productId || !window.__pageflyProducts) return null;

    return window.__pageflyProducts[String(productId)] || window.__pageflyProducts[productId] || null;
  }

  function findHandle(priceWrap) {
    var scope = priceWrap.closest('form') || priceWrap.closest('.pf-slide') || priceWrap.parentElement;
    if (!scope) return null;

    var title = scope.querySelector('[data-pf-type="ProductTitle"][data-href], [data-product-type="title"][data-href]');
    if (!title) return null;

    return getHandleFromUrl(title.getAttribute('data-href'));
  }

  function isSaleContext(priceWrap) {
    var path = window.location.pathname || '';
    if (path.indexOf('/collections/kupondui-xiang-shang-pin') !== -1) return true;

    var scope = priceWrap.closest('section') || priceWrap.closest('[data-pf-type="ProductList2"]');
    var text = scope ? scope.textContent || '' : '';

    return text.indexOf('期間限定クーポン対象アイテム') !== -1 ||
      text.indexOf('今月限定価格') !== -1;
  }

  function applyPrice(priceWrap, product) {
    if (!priceWrap || !product) return;

    var variants = Array.isArray(product.variants) ? product.variants : [];
    var variant = product.selected_variant || product.selected_or_first_available_variant || variants.find(function (item) {
      return item && item.available;
    }) || variants[0] || {};
    var basePrice = Number(variant.price || product.price || 0);
    var compareAtPrice = Number(variant.compare_at_price || product.compare_at_price || 0);
    var salePercent = parseSalePercent(product.tags);
    var salePrice = basePrice;
    var regularPrice = compareAtPrice;

    if (isSaleExcluded(product)) {
      salePercent = 0;
    } else if (!salePercent && isSaleContext(priceWrap)) {
      salePercent = 20;
    }

    if (compareAtPrice > basePrice) {
      salePercent = Math.round(((compareAtPrice - basePrice) * 100) / compareAtPrice);
    } else if (salePercent > 0) {
      salePrice = Math.floor((basePrice * (100 - salePercent)) / 100);
      regularPrice = basePrice;
    }

    if (!regularPrice || regularPrice <= salePrice || salePercent <= 0) return;

    priceWrap.classList.add('remente-price--sale');
    priceWrap.setAttribute('data-remente-sale-price-ready', 'true');
    priceWrap.innerHTML =
      '<span class="remente-price__current">' + formatMoney(salePrice) + '</span>' +
      '<span class="remente-price__compare">' + formatMoney(regularPrice) + '</span>' +
      '<small class="remente-price__savings">Special SALE ' + salePercent + '%OFF (-' +
      formatMoney(regularPrice - salePrice) + ')</small>';
  }

  function hydratePageflyPrices() {
    var priceWraps = document.querySelectorAll('[data-pf-type="ProductPrice2"]:not([data-remente-sale-price-ready])');

    priceWraps.forEach(function (priceWrap) {
      if (processed.has(priceWrap)) return;
      var productData = findProductData(priceWrap);
      var handle = findHandle(priceWrap);
      if (!productData && !handle) return;

      processed.add(priceWrap);
      (productData ? Promise.resolve(productData) : getProduct(handle)).then(function (product) {
        applyPrice(priceWrap, product);
      });
    });
  }

  function start() {
    hydratePageflyPrices();

    var observer = new MutationObserver(function () {
      hydratePageflyPrices();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
